// extracted by mini-css-extract-plugin
export default {"applyWidth":"RenameAnalysisModal_applyWidth_KlAMv","sectionContainer":"RenameAnalysisModal_sectionContainer_Hq5XI","fieldContainer":"RenameAnalysisModal_fieldContainer_XuIeg"};